import {Component, EventEmitter, Input, Output, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, NgModel} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {NlrpFieldRecordFormerTenureService} from './field-record-former-tenure.service';
import {NlrFieldRecordFomerTenureModalDataService} from './field-record-former-tenure-modalData.service';
import {ParentPlanType} from '../../../../lodge-field-record/lodge-field-record.model';
import {NlrPatternDirective} from '../../../directive/nlr-pattern.directive';
import {PATTERNS} from '../../../constants';
import {NgEventBus} from 'ng-event-bus';
import {isValidNumber, isValidString} from '../../../service/data-util';
import {NlrFormFieldHasErrorPipe} from '../../../pipe/nlr-form-field-has-error.pipe';
import {forkJoinDefaultIfEmpty} from '../../../../common/observable.utils';
import {isUndefined} from '../../../../common/service/data-util';

const defaultLot = {prefixFrom: '', from: '', prefixTo: '', to: '', value: ''};

@Component({
    selector: 'nlr-former-tenure-modal',
    imports: [CommonModule, FormsModule, NlrPatternDirective, NlrFormFieldHasErrorPipe, NgSelectModule],
    templateUrl: './field-record-former-tenure-modal.component.html',
    styleUrls: ['../modal.scss', './field-record-former-tenure-modal.scss']
})
export class FieldRecordFormerTenureModalComponent implements OnInit {
    parentPlanTypes = [];
    formerTenureViewModels: any = undefined;
    formerTenureViewModelsInit: any = undefined;
    formerTenures: any = undefined;
    subjectLandDescriptionMaxLength = 100;
    submitted = false;
    sanitizedFormerTenures = undefined;
    sanitizedFormerTenureViewModels = undefined;
    isValid = false;
    lotPattern = PATTERNS.PARENT_LOT_RANGE_PATTERN;
    titlePattern = PATTERNS.TITLE_PATTERN;
    isTitleValid = true;

    @Input() isDisabled = false;
    @Output() modalCloseEvent = new EventEmitter<void>();
    @Output() modalSaveEvent = new EventEmitter<void>();

    constructor(
        private nlrpFieldRecordFormerTenureService: NlrpFieldRecordFormerTenureService,
        private nlrFieldRecordFomerTenureModalDataService: NlrFieldRecordFomerTenureModalDataService,
        private eventBus: NgEventBus
    ) {}

    ngOnInit(): void {
        this.nlrFieldRecordFomerTenureModalDataService.getFormerTenures().subscribe(data => {
            this.formerTenures = this.deepCopy(data);
            this.formerTenureViewModelsInit = this.formerTenures.map(formerTenure => {
                return {
                    parentPlanType: formerTenure.parentPlanType,
                    parentPlanNumber: formerTenure.parentPlanNumber,
                    subjectLandDescription: formerTenure.subjectLandDescription,
                    title: formerTenure.title,
                    lotRanges: this.nlrpFieldRecordFormerTenureService.reduceRanges(formerTenure.lotRanges).map(lotRange => {
                        if (!lotRange || !lotRange.from || !lotRange.to) {
                            return {value: ''};
                        }
                        if (lotRange.from === lotRange.to) {
                            return {value: '' + lotRange.from.lotPrefix + lotRange.from.lotNumber};
                        }
                        return {value: '' + lotRange.from.lotPrefix + lotRange.from.lotNumber + '-' + lotRange.to.lotPrefix + lotRange.to.lotNumber};
                    })
                };
            });

            if (this.formerTenureViewModelsInit.length === 0) {
                this.addFormerTenure(0);
            }
        });

        this.nlrFieldRecordFomerTenureModalDataService.getParentPlanTypes().subscribe(data => {
            this.parentPlanTypes = this.deepCopy(data);
        });
    }

    deepCopy(obj: any): any {
        return JSON.parse(JSON.stringify(obj));
    }

    saveModalData() {
        this.nlrFieldRecordFomerTenureModalDataService.saveFormerTenures(this.sanitizedFormerTenures);
        this.modalSaveEvent.emit();
    }

    dismissModal() {
        this.modalCloseEvent.emit();
    }

    getParentType(parentPlanType: string) {
        if (parentPlanType) {
            return this.parentPlanTypes.filter(v => {
                return v.code === parentPlanType;
            })[0].name;
        }
    }

    addFormerTenure(index: number) {
        const idx = index !== undefined ? index + 1 : this.formerTenureViewModelsInit.length;
        this.formerTenureViewModelsInit.splice(idx, 0, {parentPlanType: null, title: '', lotRanges: [{value: ''}], subjectLandDescription: ''});
    }

    removeFormerTenure(index: number) {
        this.formerTenureViewModelsInit.splice(index, 1);
        if (this.formerTenureViewModelsInit.length === 0) {
            this.addFormerTenure(0);
        }
    }

    addLotRange(formerTenureIdx: number, lotRangeIdx: number) {
        this.formerTenureViewModelsInit[formerTenureIdx].lotRanges.splice(lotRangeIdx + 1, 0, {value: ''});
    }

    removeLotRange(formerTenureIdx: number, lotRangeIdx: number) {
        this.formerTenureViewModelsInit[formerTenureIdx].lotRanges.splice(lotRangeIdx, 1);
        if (this.formerTenureViewModelsInit[formerTenureIdx].lotRanges.length === 0) {
            this.formerTenureViewModelsInit[formerTenureIdx].lotRanges.push({value: ''});
        }
    }

    getParentTypeObj(index: number) {
        if (this.formerTenureViewModelsInit[index].parentPlanType) {
            return this.parentPlanTypes.filter(v => {
                return v.id === this.formerTenureViewModelsInit[index].parentPlanType;
            })[0];
        }
    }

    updateSelectedParentType(parentPlanType: ParentPlanType, formerTenureIdx: number) {
        this.formerTenureViewModelsInit[formerTenureIdx].parentPlanType = parentPlanType.id;
        if (this.getParentTypeObj(formerTenureIdx).displaySubjectLandDescription) {
            this.formerTenureViewModelsInit[formerTenureIdx].lotRanges = [];
        } else {
            this.formerTenureViewModelsInit[formerTenureIdx].lotRanges = [{value: ''}];
            if (this.formerTenureViewModelsInit[formerTenureIdx].title) {
                delete this.formerTenureViewModelsInit[formerTenureIdx].title;
            }
            if (this.formerTenureViewModelsInit[formerTenureIdx].subjectLandDescription) {
                delete this.formerTenureViewModelsInit[formerTenureIdx].subjectLandDescription;
            }
        }

        this.resetValidation(formerTenureIdx);
    }

    onTitleChange(newValue: string, ngModelRef: NgModel, index: number) {
        this.isTitleValid = ngModelRef.valid && isValidString(newValue);
        this.formerTenureViewModelsInit[index].title = newValue;
        this.resetVerifyResult();
    }

    onParentPlanNumberChange(newValue: number, index: number) {
        this.formerTenureViewModelsInit[index].parentPlanNumber = newValue;
        this.resetVerifyResult();
    }

    onSubjectLandDescriptionChange(newValue: number, index: number) {
        this.formerTenureViewModelsInit[index].subjectLandDescription = newValue;
        this.resetVerifyResult();
    }

    getSubjectLandDescriptionCharactersRemaining(formerTenureIdx: number) {
        const formerTenureViewModel = this.formerTenureViewModelsInit[formerTenureIdx];

        if (!this.formerTenureViewModelsInit[formerTenureIdx].subjectLandDescription) {
            return this.subjectLandDescriptionMaxLength;
        }

        const newLineCount = formerTenureViewModel.subjectLandDescription.split('\n').length - 1;
        const characterCount = formerTenureViewModel.subjectLandDescription.length - newLineCount;

        return this.subjectLandDescriptionMaxLength - characterCount;
    }

    onLotRangeChange(newValue: string, formerTenureIdx: number, lotRangeIndex: number) {
        this.formerTenureViewModelsInit[formerTenureIdx].lotRanges[lotRangeIndex].value = newValue;
        this.resetVerifyResult();
    }

    verify() {
        this.formerTenureViewModelsInit.forEach((v, i) => {
            this.resetValidation(i);
        });

        this.submitted = true;

        //Sanitize former tenures.
        const newFormerTenures = this.nlrpFieldRecordFormerTenureService.parseFormerTenures(this.formerTenureViewModelsInit);

        if (newFormerTenures.every(tenure => isUndefined(tenure.parentPlanType))) {
            return;
        }

        this.sanitizedFormerTenures = [];
        this.sanitizedFormerTenureViewModels = [];

        newFormerTenures.forEach((v, i) => {
            this.sanitizedFormerTenures[i] = JSON.parse(JSON.stringify(v));
            this.sanitizedFormerTenureViewModels[i] = JSON.parse(JSON.stringify(v));

            if (this.sanitizedFormerTenureViewModels[i].parentPlanType) {
                const parentPlanTypeCode = this.sanitizedFormerTenureViewModels[i].parentPlanType;
                this.sanitizedFormerTenureViewModels[i].parentPlanType = this.parentPlanTypes.filter(v => {
                    return v.id === parentPlanTypeCode;
                })[0].name;
            }

            const matchingFormerTenures = this.formerTenureViewModelsInit.filter(formerTenureViewModel => {
                return (
                    ((formerTenureViewModel.title || formerTenureViewModel.subjectLandDescription) &&
                        formerTenureViewModel.title === v.title &&
                        formerTenureViewModel.subjectLandDescription === v.subjectLandDescription) ||
                    (formerTenureViewModel.parentPlanType === v.parentPlanType &&
                        formerTenureViewModel.parentPlanNumber &&
                        formerTenureViewModel.parentPlanNumber === v.parentPlanNumber)
                );
            });

            if (v.title) {
                const subscription = this.nlrpFieldRecordFormerTenureService.getTitleStatus(v.title).subscribe({
                    next: res => {
                        const titleStatus = res;
                        matchingFormerTenures.forEach(formerTenureViewModel => {
                            if (titleStatus === 'CURRENT') {
                                formerTenureViewModel.validationErrors = [];
                            } else {
                                formerTenureViewModel.validationErrors = ['Title is not current'];
                            }
                        });
                        this.isValid = true;
                    },
                    error: error => {
                        console.error('nlrpFieldRecordFormerTenureService.getTitle() error: ' + error.message);
                        matchingFormerTenures.forEach(formerTenureViewModel => {
                            formerTenureViewModel.validationErrors = ['Error getting title'];
                        });
                    }
                });
                this.eventBus.cast('nlr:busy', subscription);
            } else if (v.subjectLandDescription) {
                matchingFormerTenures.forEach(formerTenureViewModel => {
                    formerTenureViewModel.validationErrors = [];
                });
                this.isValid = true;
            } else if (v.lotRanges) {
                const subscription = forkJoinDefaultIfEmpty(
                    v.lotRanges.map(lotRange => {
                        const lotRangeFrom = (lotRange.from.lotPrefix ? lotRange.from.lotPrefix : '').concat(lotRange.from.lotNumber);
                        const lotRangeTo = (lotRange.to.prefixTo ? lotRange.to.prefixTo : '').concat(lotRange.to.to);
                        return this.nlrpFieldRecordFormerTenureService.getLotsInRange(
                            v.parentPlanType,
                            v.parentPlanNumber,
                            lotRangeFrom,
                            lotRangeFrom
                        );
                    })
                ).subscribe({
                    next: responses => {
                        const lots = responses.reduce((acc, response) => {
                            response.forEach(responseLot => {
                                if (
                                    acc.filter(lot => {
                                        return lot.lotId === responseLot.lotId;
                                    }).length === 0
                                ) {
                                    acc.push(responseLot);
                                }
                            });
                            return acc;
                        }, []);

                        this.sanitizedFormerTenures[i].lotRanges = this.nlrpFieldRecordFormerTenureService.lotsToRanges(lots);
                        this.sanitizedFormerTenureViewModels[i].lotRanges = JSON.parse(JSON.stringify(this.sanitizedFormerTenures[i].lotRanges));

                        matchingFormerTenures.forEach(function (formerTenureViewModel) {
                            formerTenureViewModel.validationErrors = [];
                        });
                        this.isValid = responses.length > 0;
                    },
                    error: error => {
                        console.error(error);
                        this.formerTenureViewModelsInit[i].validationErrors = [error.error];
                        this.isValid = false;
                    }
                });

                this.eventBus.cast('nlr:busy', subscription);
            }
        });
    }

    resetValidation(i: any) {
        const formerTenureViewModel = this.formerTenureViewModelsInit[i];
        if (formerTenureViewModel.validationErrors) {
            delete formerTenureViewModel.validationErrors;
        }
        this.submitted = false;
        this.isValid = false;
    }

    isPlanTypeInValid(index: number) {
        return !isValidString(this.formerTenureViewModelsInit[index].parentPlanType) && this.submitted;
    }

    isParentPlanNumberInValid(index: number) {
        return !isValidNumber(this.formerTenureViewModelsInit[index].parentPlanNumber) && this.submitted;
    }

    isParentLotsInValid(formerTenureIndex: number, lotRangeIndex: number) {
        return !isValidString(this.formerTenureViewModelsInit[formerTenureIndex].lotRanges[lotRangeIndex].value) && this.submitted;
    }

    isTitleInvalid(index: number) {
        return (
            !isValidString(this.formerTenureViewModelsInit[index].title) &&
            !this.formerTenureViewModelsInit[index].subjectLandDescription &&
            this.submitted
        );
    }

    isLandDescriptionInvalid(index: number) {
        return (
            !isValidString(this.formerTenureViewModelsInit[index].subjectLandDescription) &&
            !this.formerTenureViewModelsInit[index].title &&
            this.submitted
        );
    }

    resetVerifyResult() {
        this.isValid = false;
    }
}
